<template>
  <tr>
      <td><span v-if="loading"><i class="fa fa-spinner fa-spin"></i></span><span v-else>{{index + 1}}</span></td>
      <td :class="[loading ? 'text-muted' : '', 'small']">{{item.created_at | orderDate}}<br><span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{item.created_at | orderDate(true)}}</span></td>
      <td :class="[loading ? 'text-muted' : '']">{{item.order_id}}</td>
      <td :class="[loading ? 'text-muted' : '']">{{item.order_item_line_id}}</td>
      <td :class="[loading ? 'text-muted' : '']"><a target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${item.sku.split('-')[0]}.html`">{{item.sku}}<br/>{{item.gtin}}</a></td>
      <template v-if="type === 'merchant'">
        <td :class="[loading ? 'text-muted' : '']">{{item.name}}</td>
      </template>
    <td :class="[loading ? 'text-muted' : '']">{{item.item_price | currency }}</td>
      <td><img class="img-responsive img-channel" :src="`/static/img/${item.sales_channel}.svg`"></td>

    <td :class="[loading ? 'text-muted' : '', 'text-center']"><button class="btn btn-default" @click="$emit('toggleSecondRow')">{{'in_schuhe' | translate}}</button></td>
      <td :class="[loading ? 'text-muted' : '', 'text-center']"><button :disabled="disabled" class="btn btn-sm btn-danger" @click="cancel(item.order_item_line_id)">{{'cancel_line' | translate}}<i class="fa fa-ban ml-5"></i></button></td>
    </tr>
</template>
<script>
  export default {
    props: ['item', 'index', 'type', 'loading'],
    data () {
      return {
        disabled: false,
        spinning: false,
        secondRow: true
      }
    },
    methods: {
      cancel (id) {
        //this.disabled = true
        this.$emit('open', {id: id, type: this.type})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/TableRows/MonitoringRow.vue